__turbopack_context__.v({
  "container": "GxZeSW_container",
  "lockIcon": "GxZeSW_lockIcon",
  "small": "GxZeSW_small",
  "textfield": "GxZeSW_textfield",
});
